'use client';

import type { FC, PropsWithChildren } from 'react';
import { Divider } from '../Divider';
import { Typography } from '../Typography';
import type { ContextualPopupProps } from './ContextualPopup';
import { ContextualPopup } from './ContextualPopup';
import { ContextualPopupHeading } from './ContextualPopupHeading';
import { ContextualPopupSection } from './ContextualPopupSection';

export interface ContextualPopupHelpProps extends ContextualPopupProps {
  heading: string;
  description: string;
  link?: string;
}

export const ContextualPopupHelp: FC<
  PropsWithChildren<ContextualPopupHelpProps>
> = ({ handle, heading, description, link, ...props }) => (
  <Typography.Mark variant="transparent">
    <ContextualPopup
      behaviour="click"
      handle={
        <>
          {handle}
          <Typography.Base opacity={0.5}>
            <sup>?</sup>
          </Typography.Base>
        </>
      }
      {...props}
    >
      <ContextualPopupHeading>{heading}</ContextualPopupHeading>
      <ContextualPopupSection>
        <Typography.Caption textAlign="center">
          {description}
        </Typography.Caption>
      </ContextualPopupSection>

      {link && (
        <>
          <Divider.Horizontal />
          <ContextualPopupSection>
            <Typography.Caption textAlign="center" lineBreak="anywhere">
              <Typography.Link href={link}>{link}</Typography.Link>
            </Typography.Caption>
          </ContextualPopupSection>
        </>
      )}
    </ContextualPopup>
  </Typography.Mark>
);
